define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/dom-class",
	"dojo/dom-style",
	"dojo/aspect",
	"csi",
	"csi/gallery/Widget",
	"csi/html",
], function(declare, lang, domClass, domStyle, aspect, csi, Widget, html) {

	var _slickTimer = null; 	// timer handle. We set it to 0 when release the timer;
	var _slickPaused = false;	// pause Slick when mouse is inside slick control;
	var _announcements = null;  // JQuery object for announcements;
	var _slickCreated = false;
	var _slickCurrentSlide = 0;

	function _slickCreate() {
		if (_slickCreated) {
			return;
		}

		_announcements.slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			dots: true,
			autoplay: false,
			variableWidth: false,
			fade: true,
			speed: 250,
			adaptiveHeight: true,
			initialSlide: _slickCurrentSlide
		});

		_slickCreated = true;

		_announcements.css("margin-bottom", "5px"); 	// fight against ".slick-slider" margin-bottom:30px;
		var slickDots = $(".announcements .slick-dots").detach(); 		// move slick slider to countWrapper panel ;
		slickDots.css({ 	// position dots at the bottom of announcements;
			"position": "static",
			"bottom": "0",
			"margin-top": "0",
			"margin-bottom": "5px"
		});
		_announcements.parent().append(slickDots);

		_slickTimerStart();
	}

	function _slickDestroy() {
		_slickTimerStop();
		if (_slickCreated) {
			_announcements.slick("unslick");
			_slickCreated = false;
		}
	}

	function _slickNext() {
		if (!_slickCreated) {
			_slickCreate();
		} else {
			_announcements.slick("slickNext");
		}
	}

	function _slickRestart() {
		_slickDestroy();
		_slickCreate();
	}

	function _slickTimerStart() {
		if (!_slickTimer) {
			_slickTimer = setInterval(_slickOnTimer, 3000);
		}
	}

	function _slickTimerStop() {
		if (_slickTimer) {
			clearInterval(_slickTimer);
			_slickTimer = null;
		}
	}

	function _slickTimerRestart() {
		_slickTimerStop();
		_slickTimerStart();
	}

	function _slickVisible() {
		return _announcements[0].clientWidth ? true : false; // width will be zero if not visible (another tab)
	}

	function _slickOnTimer() {
		// Paused when mouse is within announcements
		if (_slickPaused) {
			return;
		}

		if (_slickVisible()) {
			_slickNext();
		} else {
			_slickTimerStop();
		}
	}

	return declare(Widget, {
		emptyMessageResource: "AnnouncementsEmpty",

		hidePlaceholder: true,

		getFadeNode: function() {
			// summary: disable fading by returning null
			return null;
		},

		_buildViewResults: function(/*QueryResults*/results, /*Boolean*/bRefresh) {
			// summary: render view after template and data loaded
			var contentRoot = this.getContentRoot();

			// Erase existing view
			_slickDestroy();
			html.destroyChildren(contentRoot);

			// Crete new view
			var n = results.length;
			if (n) {
				domClass.add(this.domNode, "csi-announcements");

				var contentDiv = html.create("div", {"class": "announcements"}, contentRoot, "first");
				var eContentWidth = domStyle.get(contentRoot, "width");
				domStyle.set(contentDiv, "width", eContentWidth + "px");

				var ctx = this.getContext(csi.EMPTY_URL);
				ctx.forEach(results, function(ctx) {
					var blockNode = lang.clone(this.blockNode);
					this.setRefNodeId(blockNode, ctx.getNodeURL());
					this._addBlockStyling(blockNode);
					this._processHtml(ctx, blockNode);
					contentDiv.appendChild(blockNode);
				}, this);

				_announcements = $(contentDiv);

				if (n > 1) {
					if (n >= _slickCurrentSlide) { // in case if we deleted some announcements
						_slickCurrentSlide = 0;
					}

					_slickCreate();

					// preserve slide number when re-starting or re-creating Slick (Slick event)
					_announcements.on("afterChange", function(ev, slick, currentSlide) {
						_slickCurrentSlide = currentSlide;
					});

					// TitlePane expand event
					this.own(aspect.after(this.getParent(), "onShow", _slickNext));

					// TitlePane collapse event
					this.own(aspect.after(this.getParent(), "onHide", _slickDestroy));

					// pause Slick when mouse enters announcements
					$(contentRoot).mouseenter(function() {
						_slickPaused = true;
					});

					// when mouse leaves announcements re-start the timer
					// to avoid immediate slide change, and activate Slick
					$(contentRoot).mouseleave(function() {
						_slickTimerRestart();
						_slickPaused = false;

					});
				}
			}

			if (this.moreNode) {
				html.destroyElement(this.moreNode);
				delete this.moreNode;
			}
		},

		destroy: function(/*Boolean*/preserveDom) {
			this.inherited(arguments);
			_slickDestroy(); // safe call
		},

		onTabSwitch: function() {
			// act when view tab becomes active, re-start or re-create Slick
			this.inherited(arguments);

			if (_slickCreated) {
				if (_slickVisible()) {
					if ($(".announcements .slick-slide").width()) {
						_slickTimerStart(); // resume slides rotation
					} else {
						_slickRestart(); // prevent flicker
					}
				}
			}
		},

		_onResize: function() {
			// summary: listen for resize events, as we need to set exact width for Slick.
			if (!_announcements) {
				return;
			}

			_announcements.css("width", "0");
			this.inherited(arguments);
			var eContentWidth = domStyle.get(this.getContentRoot(), "width");
			_announcements.css("width", eContentWidth + "px");
		}
	});
});